import ru from '@vueCommon/locales/ru.js';

export default {
  ...ru,
};
